import PropTypes from 'prop-types'
import {StyledNewChatButton} from '../ChatViewStyles'

const NewChat = ({loader, handleNewChat}) => {
  return (
    <StyledNewChatButton onClick={handleNewChat} disabled={loader}>
      Start a new chat
    </StyledNewChatButton>
  )
}

NewChat.propTypes = {
  handleNewChat: PropTypes.func.isRequired,
  loader: PropTypes.bool.isRequired
}

export default NewChat
